import React, {Fragment} from 'react'
import styled from 'styled-components';
import colors from '../../lib/Colors';
import fonts from '../../lib/Fonts';
import I18n from 'i18n-js';

const Body404 = styled.div`
  width: 100%;
  height: 100%;
  background: ${colors.orange};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Header404 = styled.div`
  font-family: ${fonts.family.workSans};
  color: ${colors.lightestGray};
`;

const Title404 = styled.div`
  color: ${colors.lightestGray};
  font-size: 10em;
`;



const Line = styled.div`
  border-left: 12px solid transparent;
  border-bottom: 16px solid #efefef;
`;

const Line1 = styled(Line)`
   margin: 0 0 15px 106px;
`;

const Line2 = styled(Line)`
   margin: 0 0 15px 87px;
    width: 156px;
`;

const Line3 = styled(Line)`
   margin: 0 0 0 68px;
   width: 175px;
`;

const Line0 = styled(Line)`
   border-left: 0;
   margin-bottom: 10px;
`;

const Text404 = styled.span`
  font-size: 1.5em;
`;


export class NotFound extends React.Component {
  render() {
    return (
      <Fragment>
        <Body404>
          <Header404>
            <Line1/>
            <Line2/>
            <Line3/>
            <Title404>404</Title404>
            <Line0/>
            <Text404>{I18n.t('shared.message404')}</Text404>
          </Header404>
        </Body404>
      </Fragment>
    )
  }
}

NotFound.propTypes = {};

NotFound.defaultProps = {};

export default NotFound
